
export function SinPuestos({ toggle}) {
  return (
    <div style={{ paddingTop: 25  }}>
      <h1>Aun no tienes puestos creados</h1>
      <h1>Crea tu primer puesto haciendo click <i onClick={() => toggle()} className="text_underline">aquí</i> </h1>
    </div>
  )
}
